import React, { useState, Suspense, lazy, useMemo } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_USER_ACCESS,
  INVITE_AUTH,
  delete_User,
} from "../../../services/constants";
import addUserIcon from "../../Assets/Profile/add-user.svg";
import Avtar from "./avtar.component";
import { ReactComponent as CrossIcon } from "../../Assets/rank-tracking-assets/cross.svg";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from "./spinner";
import { ZustandStore } from "../../../store/zustand-store";
import { useTranslation } from "react-i18next";

import AvatarGroup from "@mui/material/AvatarGroup";

const InviteUserDialog = lazy(() => import("./inviteUserDialog"));

const SubUserDetails = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const adminMail = localStorage.getItem("admin_mail");

  const [UserId, setUserId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [showInvite, setShowInvite] = useState(false);
  const [UpdateAccess, setUpdateAccess] = useState([]);

  const { customer_plan } = ZustandStore((state) => state);

  const email = useSelector((state) => state.email);
  const subuserinvitelength = useSelector((state) => state.subuserinvitelength);

  const invited_user =
    adminMail?.toLocaleLowerCase() === email?.toLocaleLowerCase();

  const isCustomerPlanEmpty = useMemo(
    () => customer_plan?.length === 0,
    [customer_plan]
  );

  const hasSubUsers = useMemo(
    () => subuserinvitelength?.length > 0,
    [subuserinvitelength]
  );

  const deleteUser = async () => {
    try {
      await axios.delete(delete_User(UserId));
      const res = await axios.get(INVITE_AUTH(email));
      dispatch({ type: "SUBUSERINVITELENGTH", payload: res.data });
      setUserId(null);
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const handleUpdateAccess = async (email) => {
    setLoading(true);
    try {
      const response = await axios.get(GET_USER_ACCESS(email));
      setUpdateAccess(response.data);
      setShowInvite(true);
    } catch (error) {
      console.error("Failed to fetch user access:", error);
    } finally {
      setLoading(false);
      setShowDetail(false);
    }
  };

  const renderedAvatars = useMemo(
    () => (
      <AvatarGroup max={4}>
        {subuserinvitelength.map((user) => (
          <Avtar user_name={user?.name} size={"40px"} key={user?.name} />
        ))}
      </AvatarGroup>
    ),
    [subuserinvitelength]
  );

  return (
    <>
      {showInvite && (
        <Suspense fallback={<Spinner />}>
          <InviteUserDialog
            {...{
              UpdateAccess,
              setUpdateAccess,
              showInvite,
              setShowInvite,
            }}
          />
        </Suspense>
      )}
      {showDetail && (
        <div className="pop user-detl-dialog">
          <div
            className="popBodySeoImpactTool"
            style={{
              minWidth: "300px",
              transform: "scale(.9)",
              width: "calc(100% - 65px)",
              minHeight: "300px",
            }}
          >
            {loading ? (
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ minHeight: "300px" }}
              >
                <Spinner />
              </div>
            ) : (
              <>
                <div className="SeoImpactHeadTool">
                  <h5 className="mb-0 heading-large font-bold">
                    {t("profile.sub_user_list")}
                  </h5>
                  <CrossIcon
                    style={{
                      width: "30px",
                      height: "30px",
                      float: "right",
                      cursor: "pointer",
                      top: "15px",
                    }}
                    onClick={() => setShowDetail(false)}
                  />
                </div>

                <div className="pop-form py-2 py-lg-4">
                  <div className="listModalHeightTool list-scroll">
                    <div className="profile-table-container">
                      <table className="table mb-0 profile-table mt-0">
                        <thead>
                          <tr>
                            <th scope="col">{t("profile.name")}</th>
                            <th scope="col">{t("profile.email")}</th>
                            <th scope="col"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {hasSubUsers ? (
                            subuserinvitelength?.map((res, key) => (
                              <tr key={res.name}>
                                <td>{res.name}</td>
                                <td>{res.email}</td>
                                <td className="text-end">
                                  {res.id === UserId ? (
                                    <div>
                                      <span onClick={() => setUserId(null)}>
                                        <i className="fa-solid fa-xmark text-success"></i>
                                      </span>
                                      <span
                                        className="ms-3 point"
                                        onClick={() => deleteUser()}
                                      >
                                        <i className="fa-solid fa-check text-danger"></i>
                                      </span>
                                    </div>
                                  ) : (
                                    <>
                                      <EditIcon
                                        style={{ color: "#365486" }}
                                        titleAccess="Update access"
                                        className="me-2 point"
                                        onClick={() =>
                                          handleUpdateAccess(res.email)
                                        }
                                      />
                                      <DeleteIcon
                                        className="point"
                                        color="error"
                                        titleAccess="Delete user"
                                        onClick={() => setUserId(res.id)}
                                      />
                                    </>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={3} className="text-center">
                                {t("profile.no_subuser")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      <div className="w-100 user-list-info">
        <div>
          <h2 className="profile-heading mb-2">{t("profile.sub_user")}</h2>
          <div className="user-image">
            {isCustomerPlanEmpty ? (
              <img src={addUserIcon} alt="add-user" className="add-user" />
            ) : (
              <img
                src={addUserIcon}
                alt="add-user"
                className="add-user point"
                onClick={() => {
                  invited_user && setShowInvite(true);
                }}
              />
            )}
            {renderedAvatars}
          </div>
        </div>
        {!invited_user ? (
          <div className="d-flex flex-column align-items-cnter">
            <p className="msg-error text-start mb-0">
              {t("profile.cannot_invite")}{" "}
            </p>
            <span style={{ color: "black" }}>{adminMail}</span>
          </div>
        ) : (
          <div className="cmd">
            {hasSubUsers ? (
              <button
                className="Pr-btn mt-2"
                style={{ height: "40px", minWidth: "100px" }}
                onClick={() => setShowDetail(true)}
                disabled={isCustomerPlanEmpty}
              >
                {t("profile.view_detail")}
              </button>
            ) : (
              <button
                className="Pr-btn ms-1 mt-2"
                style={{ height: "40px", minWidth: "100px" }}
                onClick={() => setShowInvite(true)}
                disabled={isCustomerPlanEmpty || !invited_user}
              >
                {t("profile.invite_user")}
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default SubUserDetails;
